import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { Localiser } from '../../services/localiser';
import { LuminariaService } from '../../services/luminaria.service';
import { luminaria } from '../../models/luminaria';
import { concentrador } from '../../models/concentrador';
import {ConcentradorService} from '../../services/concentrador.service';
import {sensor} from "../../models/sensor";
import {SensorService} from "../../services/sensor.service";
import {ZonaService} from "../../services/zona.service";
import {zona} from "../../models/zona";
import {proyecto} from "../../models/proyecto";
import {plano} from "../../models/plano";
import {UserService} from "../../services/user.service";
import {ProyectoService} from "../../services/proyecto.service";
import {PlanoService} from "../../services/plano.service";
import {Navigation} from "../../services/navigation.service";
import {DeviceService} from "../../services/device.service";
import {MatDialog} from "@angular/material/dialog";
import {EditComponent} from "./edit/edit.component";
import {sensorData} from "../../models/sensorData";
import {EditConcentradorComponent} from "./edit-concentrador/edit-concentrador.component";
import {EditSensorComponent} from "./edit-sensor/edit-sensor.component";
import {daliData} from "../../models/daliData";
import {DeleteComponent} from "./delete/delete.component";
import {OptionsComponent} from "./options/options.component";
import { ParametrosService } from 'src/app/services/parametros.service';
import { parametros } from 'src/app/models/parametros';
import {finalize, timeout} from "rxjs/operators";

// Algo por encima del timeout de 10s del backend, para que gane su respuesta TIMEOUT
const PERIPHERALS_REQUEST_TIMEOUT_MS = 15000;

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css']
})
export class DevicesComponent implements AfterViewInit, OnDestroy {

  luminarias: Array<luminaria> = [];
  luminariasOrder:  Array<luminaria> = [];
  luminariasFiltro: Array<luminaria> = [];
  luminariasFiltroUbicacion: Array<luminaria> = [];
  luminariasReal: Array<luminaria> = [];
  luminariasNumber: number = undefined;
  loadingLums: boolean = true;
  actualPage: number = 1;
  zonas: Array<zona> = [];
  proyectos: Array<proyecto> = [];
  planos: Array<plano> = [];
  gridView: boolean = false;
  luminariasOpen: boolean = false;
  luminariasFilterOpen: boolean = false;
  concentradores: Array<concentrador> = [];
  concentradoresFiltro: Array<concentrador> = [];
  concentradoresFiltroUbicacion: Array<concentrador> = [];
  concentradoresReal: Array<concentrador> = [];
  duplicateGatewayIds: Set<string> = new Set();
  concentradoresOpen: boolean = false;
  concentradoresFilterOpen: boolean = false;
  sensores: Array<sensor> = [];
  sensoresFiltro: Array<sensor> = [];
  sensoresFiltroUbicacion: Array<sensor> = [];
  sensoresReal: Array<sensor> = [];
  sensoresOpen: boolean = false;
  sensoresFilterOpen: boolean = false;

  showingDaliData: boolean = false;
  loadingDaliDataTable: boolean = false;
  daliDataNumber: number = undefined;
  actualDaliDataPage: number = 1;
  orderDaliData: boolean = false;
  requestingDaliData: boolean = false;
  daliDataAvailabilityByLuminariaId: {[luminariaId: string]: boolean} = {};
  loadingDaliDataAvailabilityByLuminariaId: {[luminariaId: string]: boolean} = {};
  requestingPeripheralsByLuminariaId: {[luminariaId: string]: boolean} = {};
  selectedLuminaria: luminaria = undefined;
  selectedProyecto: proyecto = undefined;
  selectedPlano: plano = undefined;
  selectedZona: zona = undefined;
  selectedGWFilterLum: string = undefined;
  selectedFirmwareVersionFilterLum: string = undefined;
  selectedEmergenciesFilterLum: boolean = false;
  selectedPresenceSensorsFilterLum: boolean = false;
  selected420SensorsFilterLum: boolean = false;
  selectedChannelFilterGW: string = undefined;
  selectedFirmwareVersionFilterGW: string = undefined;
  selectedCommunicatingFilterGW: boolean = true;
  selectedAllFilterSensor: boolean = true;
  selected420FilterSensor: boolean = true;
  selectedPresenceFilterSensor: boolean = true;
  selectedBothFilterSensor: boolean = true;
  selectedLuminariaByFloorplan: string = undefined;

  showingSensorData: boolean = false;
  sensorDataNumber: number = undefined;
  actualSensorDataPage: number = 1;
  orderSensorData: boolean = false;
  selectedSensor: sensor = undefined;
  sensorData: sensorData[] = [];

  searcherLuminarias: string = "";
  searcherSensors: string = "";

  autoSaveInterval;

  orderValueLum = 0;
  orderVariableLum = [];
  orderValueGW = 0;
  orderVariableGW = []

  constructor(public localiser: Localiser, public luminariaService: LuminariaService,
              public concentradorService: ConcentradorService, public sensorService: SensorService,
              public zonaService: ZonaService, public user: UserService,
              public planoService: PlanoService, private navigation: Navigation,
              public proyectoService: ProyectoService, public deviceService: DeviceService,
              public matDialog: MatDialog, private  changeDetectorRef: ChangeDetectorRef,
              private parametrosService: ParametrosService, public userService: UserService) {
    this.autoSaveInterval = setInterval(() => {
      let elements = document.getElementsByClassName("flashRed");
      for (let i = 0; i < elements.length; i++) {
        let element = elements.item(i);
        if (element.classList.contains("red")) {
          element.classList.remove('red');
        } else {
          element.classList.add('red');
        }
      }
    }, 500);

  }

  ngAfterViewInit(): void {
    // pongo un setTimeout para evitar el error qu salia de NG0100 https://v17.angular.io/errors/NG0100
    this.selectProyecto(this.proyectoService.getProyectoActual());
    setTimeout(() => {
      this.init();
    }, 500);
  }

  ngOnDestroy() {
    clearInterval(this.autoSaveInterval);
  }

  init() {
    this.getLuminarias();
    this.getUbications();
    this.getConcentradores();
    this.getSensores();
  }

  getLuminarias() {
    this.luminariasReal = [];
    this.daliDataAvailabilityByLuminariaId = {};
    this.loadingDaliDataAvailabilityByLuminariaId = {};
    this.loadingLums = true;
    this.luminariaService.getCountForDevicesPage(this.user.getEmpresa()).subscribe((result: number) => {
      this.luminariasNumber = result;
      if (this.luminariasNumber > 20) {
        this.getForDevicesPageRecursive(1);
      }
    });
    this.getForDevicesPage(0);
  }

  getForDevicesPageRecursive(page) {
    if (page < Math.ceil(this.luminariasNumber / 20)) {
      this.getForDevicesPage(page);
      this.getForDevicesPageRecursive(page + 1);
    }
  }

  getForDevicesPage(page) {
    this.luminariaService.getForDevicesPage(this.user.getEmpresa(), page).subscribe((response) => {
      let luminariasResponse = <Array<luminaria>> response;
      this.luminariasReal = this.luminariasReal.concat(luminariasResponse);
      this.luminariasReal = this.luminariasReal.sort((a, b) => {
          return a.nombre.localeCompare(b.nombre);
      })
      if (this.luminariasNumber == this.luminariasReal.length) {
        this.loadingLums = false;
      }
      this.checkSelected();
      this.filterUbication();
    });
  }

  getUbications() {
    this.proyectos = this.user.getProyectos();
    this.planos = [];
    this.zonas = [];
    for (let proyecto of this.proyectos) {
      this.planoService.getByIdProyecto(proyecto.idProyecto).subscribe((response) => {
        this.planos = this.planos.concat(<Array<plano>>response);
      });
      this.zonaService.getByIdProyecto(proyecto.idProyecto).subscribe((response) => {
        this.zonas = this.zonas.concat(<Array<zona>>response);
        this.checkSelected();
      });
    }
  }

  getZonaNombreById(zonaId) {
    let zona = this.getZonaModelById(zonaId);
    if (zona == undefined) {
      return this.localiser.get("devices.unassigned");
    } else {
      return zona.nombre;
    }
  }

  getTextoEstadoConfirmacionRegla(estado_confirmacion_entero) {
    let estado = this.localiser.get("devices.rule.status.unconfirmed");

    if (estado_confirmacion_entero != undefined) {
      if (estado_confirmacion_entero == 2) {
        estado = this.localiser.get("devices.rule.status.confirmed");
      }
    }

    return estado;
  }

  getZonaModelById(zonaId) {
    return this.zonas.find(zona => zona.id == zonaId);
  }

  getPlanoNombreById(planoId) {
    let plano = this.getPlanoModelById(planoId);
    if (plano == undefined) {
      return this.localiser.get("devices.unassigned");
    } else {
      return plano.nombre;
    }
  }

  getPlanoModelById(planoId) {
    return this.planos.find(plano => plano.idPlano == planoId);
  }

  getProyectoNombreByIdProyecto(idProyecto) {
    let proyecto = this.getProyectoModelByIdProyecto(idProyecto);
    if (proyecto == undefined) {
      return this.localiser.get("devices.unassigned");
    } else {
      return proyecto.nombre;
    }
  }

  getProyectoModelByIdProyecto(idProyecto) {
    return this.proyectos.find(proyecto => proyecto.idProyecto == idProyecto);
  }

  openLuminarias() {
    this.luminariasOpen = !this.luminariasOpen;
    if (!this.luminariasOpen) {
      this.gridView = false;
      this.luminariasFilterOpen = false;
    }
  }

  changeGridView() {
    if (this.luminariasOpen) {
      this.gridView = !this.gridView;
    }
  }

  openLuminariasFilter() {
    if (this.luminariasOpen) {
      this.luminariasFilterOpen = !this.luminariasFilterOpen;
    }
  }

  getConcentradores() {
    this.concentradores = [];
    this.concentradoresReal = [];
    this.concentradorService.getByIdEmpresa(this.user.getEmpresa()).subscribe((response) => {
      this.concentradoresReal = <Array<concentrador>> response;
      this.checkSelected();
      this.filterUbication();
    });
  }

  getGatewayDisplayName(gatewayId: string, gatewayName: string) {
    if (gatewayName != null && gatewayName.trim()) {
      return gatewayName;
    }

    if (gatewayId == null || gatewayId === '') {
      return this.localiser.get("devices.noGatewayPresent");
    }

    if (this.isGatewayMissing(gatewayId)) {
      return this.localiser.get("devices.unknownGateway");
    }

    return gatewayId;
  }

  /*
    Indica si la luminaria tiene asignado un concentrador principal que ya no existe en base de datos,
    es decir, el caso en el que la columna del concentrador principal muestra "Concentrador desconocido".
  */
  isGatewayMissing(gatewayId: string) {
    if (gatewayId == null || gatewayId === '') {
      return false;
    }

    return !this.concentradoresReal.some(concentrador => concentrador.idDispositivo == gatewayId);
  }

  /*
    La flecha para pedir el MapOfHubs se muestra cuando el concentrador principal no está confirmado,
    pero también cuando está confirmado apuntando a un concentrador que ya ha sido borrado, para que el
    usuario pueda volver a forzar la petición y recuperar el concentrador principal real.
  */
  showGetHubsMap(luminaria: luminaria) {
    return !luminaria.hubPpalConfirmado || this.isGatewayMissing(luminaria.hubPpal);
  }

  openConcentradores() {
    this.concentradoresOpen = !this.concentradoresOpen;
    if (!this.concentradoresOpen) {
      this.concentradoresFilterOpen = false;
    }
  }

  openConcentradoresFilter() {
    if (this.concentradoresOpen) {
      this.concentradoresFilterOpen = !this.concentradoresFilterOpen;
    }
  }

  getSensores() {
    this.sensores = [];
    this.sensoresReal = [];
    this.sensorService.getByIdEmpresa(this.user.getEmpresa()).subscribe((response) => {
      this.sensoresReal = <Array<sensor>> response;
      this.sensoresReal = this.sensoresReal.filter(sensor => sensor.tipoSensor != 255);
      this.checkSelected();
      this.filterUbication();
    });
  }

  openSensores() {
    this.sensoresOpen = !this.sensoresOpen;
  }

  openSensoresFilter() {
    if (this.sensoresOpen) {
      this.sensoresFilterOpen = !this.sensoresFilterOpen;
    }
  }

  seeDaliData(luminaria: luminaria) {
    if (!this.canSeeDaliData(luminaria)) {
      return;
    }

    this.selectedLuminaria = luminaria;
    this.selectedLuminaria['daliDataList'] = [];
    this.showingDaliData = true;
    this.refreshDaliDataTable(true);
  }

  refreshDaliDataTable(goToLatestPage: boolean = false) {
    if (this.selectedLuminaria == undefined) {
      return;
    }

    this.loadingDaliDataTable = true;
    this.luminariaService.getCountForDaliDataPaginated(this.selectedLuminaria.idDispositivo).subscribe({
      next: (result: number) => {
        this.daliDataNumber = result;
        this.daliDataAvailabilityByLuminariaId[this.selectedLuminaria.idDispositivo] = result > 0;

        if (result <= 0) {
          this.selectedLuminaria['daliDataList'] = [];
          this.actualDaliDataPage = 1;
          this.loadingDaliDataTable = false;
          return;
        }

        let page = this.actualDaliDataPage;

        if (goToLatestPage || page == undefined) {
          page = this.orderDaliData ? Math.max(1, Math.ceil(this.daliDataNumber / 100)) : 1;
        }

        this.getDaliDataPaginated(this.selectedLuminaria.idDispositivo, page);
      },
      error: () => {
        this.daliDataNumber = 0;
        this.selectedLuminaria['daliDataList'] = [];
        this.actualDaliDataPage = 1;
        this.loadingDaliDataTable = false;
      }
    });
  }

  requestDaliData() {
    if (this.selectedLuminaria == undefined || this.requestingDaliData) {
      return;
    }

    this.requestingDaliData = true;
    this.luminariaService.requestDaliData(this.selectedLuminaria.idDispositivo)
      .pipe(finalize(() => {
        this.requestingDaliData = false;
      }))
      .subscribe({
        next: () => {
          this.refreshDaliDataTable(true);
          this.getLuminarias();
        },
        error: () => {
          this.refreshDaliDataTable(true);
        }
      });
  }

  getDaliDataPaginated(idLuminaria: string, page: number) {
    this.selectedLuminaria['daliDataList'] = [];
    if (this.daliDataNumber <= 0) {
      this.actualDaliDataPage = 1;
      this.loadingDaliDataTable = false;
      return;
    }

    if (page > Math.ceil(this.daliDataNumber / 100)) {
      page = Math.ceil(this.daliDataNumber / 100);
    }
    if (page < 1 || page == undefined) {
      page = 1;
    }
    this.actualDaliDataPage = undefined;
    this.changeDetectorRef.detectChanges();
    this.actualDaliDataPage = page;
    this.loadingDaliDataTable = true;
    this.luminariaService.getDaliDataPaginated(idLuminaria, this.actualDaliDataPage - 1, this.orderDaliData)
      .pipe(finalize(() => {
        this.loadingDaliDataTable = false;
      }))
      .subscribe({
        next: (response: daliData[]) => {
          this.selectedLuminaria['daliDataList'] = response;

          this.selectedLuminaria.daliDataList.forEach((registro: any) => {
            if (registro.cg_DERATING_TEMP == 255) {
              registro.cg_DERATING_TEMP = this.localiser.get("devices.daliData.notImplemented")
            } else if (registro.cg_DERATING_TEMP == 254) {
              registro.cg_DERATING_TEMP = this.localiser.get("devices.daliData.temporarilyNotAvailable")
            }

        if (registro.cg_UNDER_VOLTAGE == 255) {
          registro.cg_UNDER_VOLTAGE = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.cg_UNDER_VOLTAGE == 254) {
          registro.cg_UNDER_VOLTAGE = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.cg_OVER_VOLTAGE == 255) {
          registro.cg_OVER_VOLTAGE = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.cg_OVER_VOLTAGE == 254) {
          registro.cg_OVER_VOLTAGE = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.cg_SHUTDOWN_TEMP == 255) {
          registro.cg_SHUTDOWN_TEMP = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.cg_SHUTDOWN_TEMP == 254) {
          registro.cg_SHUTDOWN_TEMP = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.lg_DERATING_TEMP == 255) {
          registro.lg_DERATING_TEMP = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.lg_DERATING_TEMP == 254) {
          registro.lg_DERATING_TEMP = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.lg_SHUTDOWN_TEMP == 255) {
          registro.lg_SHUTDOWN_TEMP = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.lg_SHUTDOWN_TEMP == 254) {
          registro.lg_SHUTDOWN_TEMP = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.pcg == 255) {
          registro.pcg = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.pcg == 254) {
          registro.pcg = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.cg_ERR == 255) {
          registro.cg_ERR = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.cg_ERR == 254) {
          registro.cg_ERR = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.cg_POWER_LIMIT == 255) {
          registro.cg_POWER_LIMIT = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.cg_POWER_LIMIT == 254) {
          registro.cg_POWER_LIMIT = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.cg_TEMP == 255) {
          registro.cg_TEMP = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.cg_TEMP == 254) {
          registro.cg_TEMP = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.lg_ERR == 255) {
          registro.lg_ERR = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.lg_ERR == 254) {
          registro.lg_ERR = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.lg_SHORT_CIRCUIT == 255) {
          registro.lg_SHORT_CIRCUIT = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.lg_SHORT_CIRCUIT == 254) {
          registro.lg_SHORT_CIRCUIT = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.lg_OPEN_CIRCUIT == 255) {
          registro.lg_OPEN_CIRCUIT = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.lg_OPEN_CIRCUIT == 254) {
          registro.lg_OPEN_CIRCUIT = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.w == 4294967295) {
          registro.w = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.w == 4294967294) {
          registro.w = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

        if (registro.wh == 281474976710655) {
          registro.wh = this.localiser.get("devices.daliData.notImplemented")
        } else if (registro.wh == 281474976710654) {
          registro.wh = this.localiser.get("devices.daliData.temporarilyNotAvailable")
        }

            if (registro.life_IN_HOURS == 4294967295) {
              registro.life_IN_HOURS = this.localiser.get("devices.daliData.notImplemented")
            } else if (registro.life_IN_HOURS == 4294967294) {
              registro.life_IN_HOURS = this.localiser.get("devices.daliData.temporarilyNotAvailable")
            }
          });
        },
        error: () => {
          this.selectedLuminaria['daliDataList'] = [];
        }
      });

  }

  canSeeDaliData(luminaria: luminaria): boolean {
    if (luminaria == undefined || luminaria.perifericos == undefined || luminaria.perifericos.dali == -1) {
      return false;
    }

    return this.daliDataAvailabilityByLuminariaId[luminaria.idDispositivo] === true;
  }

  loadDaliDataAvailabilityForVisibleLuminarias() {
    this.luminarias.forEach((lum) => {
      if (lum == undefined || lum.idDispositivo == undefined) {
        return;
      }

      if (lum.perifericos == undefined || lum.perifericos.dali == -1) {
        this.daliDataAvailabilityByLuminariaId[lum.idDispositivo] = false;
        return;
      }

      if (this.daliDataAvailabilityByLuminariaId[lum.idDispositivo] != undefined
        || this.loadingDaliDataAvailabilityByLuminariaId[lum.idDispositivo] === true) {
        return;
      }

      this.loadingDaliDataAvailabilityByLuminariaId[lum.idDispositivo] = true;
      this.luminariaService.getCountForDaliDataPaginated(lum.idDispositivo)
        .pipe(finalize(() => {
          this.loadingDaliDataAvailabilityByLuminariaId[lum.idDispositivo] = false;
        }))
        .subscribe({
          next: (result: number) => {
            this.daliDataAvailabilityByLuminariaId[lum.idDispositivo] = result > 0;
          },
          error: () => {
            this.daliDataAvailabilityByLuminariaId[lum.idDispositivo] = false;
          }
        });
    });
  }

  changeOrderDaliData(order) {
    this.orderDaliData = order;
    this.refreshDaliDataTable(true);
  }

  changeDaliDataPageByNumber(page) {
    if (page != undefined) {
      this.actualDaliDataPage = undefined;
      this.changeDetectorRef.detectChanges();
      this.getDaliDataPaginated(this.selectedLuminaria.idDispositivo, page);
    }
  }

  outInputChangeDaliDataPageByNumber(event) {
    if (isNaN(event.srcElement.valueAsNumber)) {
      this.getDaliDataPaginated(this.selectedLuminaria.idDispositivo, 1);
    }
  }

  changeDaliDataPageByArrow(nextPage) {
    this.getDaliDataPaginated(this.selectedLuminaria.idDispositivo, this.actualDaliDataPage + nextPage);
  }

  isLastDaliDataPage() {
    return Math.ceil(this.daliDataNumber / 100) == this.actualDaliDataPage || Math.ceil(this.daliDataNumber / 100) <= 1;
  }

  checkSelected() {
    let selected = this.deviceService.checkSelected();
    if (selected != -1) {
      if (selected == 0) {
        this.selectProyecto(this.proyectos.find(proyecto => proyecto.idProyecto == this.deviceService.getSelectedProyecto().idProyecto));
      } else if (selected == 1) {
        this.selectPlano(this.planos.find(plano => plano.idPlano == this.deviceService.getSelectedPlano().idPlano));
      } else if (selected == 2) {
        this.selectZona(this.zonas.find(zona => zona.id == this.deviceService.getSelectedZona().id));
      } else if (selected == 3) {
        this.selectLuminaria(this.deviceService.getSelectedLuminaria());
      }
    }
  }

  // Filter by the ubication selectors
  filterUbication() {
    if (this.selectedZona) {
      this.luminariasFiltroUbicacion = this.luminariasReal.filter(device => device.idZona === this.selectedZona.id);
      this.concentradoresFiltroUbicacion = this.concentradoresReal.filter(concentrador => concentrador.idZona == this.selectedZona.id);
      this.sensoresFiltroUbicacion = this.sensoresReal.filter(sensor => sensor.idZona == this.selectedZona.id);
    } else if (this.selectedPlano) {
      this.luminariasFiltroUbicacion = this.luminariasReal.filter(device => device.idPlano === this.selectedPlano.idPlano);
      this.concentradoresFiltroUbicacion = this.concentradoresReal.filter(concentrador => concentrador.idPlano == this.selectedPlano.idPlano);
      this.sensoresFiltroUbicacion = this.sensoresReal.filter(sensor => sensor.idPlano == this.selectedPlano.idPlano);
    } else if (this.selectedProyecto) {
      this.luminariasFiltroUbicacion = this.luminariasReal.filter(device => device.idProyecto === this.selectedProyecto.idProyecto);
      this.concentradoresFiltroUbicacion = this.concentradoresReal.filter(concentrador => concentrador.idProyecto == this.selectedProyecto.idProyecto);
      this.sensoresFiltroUbicacion = this.sensoresReal.filter(sensor => sensor.idProyecto == this.selectedProyecto.idProyecto);
    } else {
      this.luminariasFiltroUbicacion = this.luminariasReal;
      this.concentradoresFiltroUbicacion = this.concentradoresReal;
      this.sensoresFiltroUbicacion = this.sensoresReal;
    }
    this.filterLumsByProperties();
    this.filterGWByProperties();
    this.filterSensorByProperties();
  }

  selectProyecto(proyecto: proyecto) {
    if (proyecto != undefined) {

      // Select and unselect
      this.selectedProyecto = proyecto;
      this.selectedPlano = undefined;
      this.selectedZona = undefined;
      this.filterUbication();
      this.setSelectedFilters();

      // Sort selectors
      this.proyectos.sort((a) => (a === this.selectedProyecto ? -1 : 0));
      this.planos.sort((a) => (a.idProyecto === this.selectedProyecto.idProyecto ? -1 : 0));

    } else {

      // Undefined
      this.selectedProyecto = undefined;
      this.selectedPlano = undefined;
      this.selectedZona = undefined;
      this.filterUbication();
    }
  }

  selectPlano(plano: plano) {
    if (plano != undefined) {

      // Select and unselect
      this.selectedProyecto = this.proyectos.find(proyecto => proyecto.idProyecto === plano.idProyecto);
      this.selectedPlano = plano;
      this.selectedZona = undefined;
      this.filterUbication();
      this.setSelectedFilters();

      // Sort selectors
      this.proyectos.sort((a) => (a === this.selectedProyecto ? -1 : 0));
      this.planos.sort((a) => (a.idProyecto === this.selectedProyecto.idProyecto ? -1 : 0));
      this.planos.sort((a) => (a === this.selectedPlano ? -1 : 0));
      this.zonas.sort((a) => (a.idPlano === this.selectedPlano.idPlano ? -1 : 0));

    } else {

      // Undefined
      this.selectedPlano = undefined;
      this.selectedZona = undefined;
      this.filterUbication();
    }
  }

  selectZona(zona: zona) {
    if (zona != undefined) {

      // Select and unselect
      this.selectedProyecto = this.proyectos.find(proyecto => proyecto.idProyecto ===
        this.planos.find(plano => plano.idPlano === zona.idPlano).idProyecto);
      this.selectedPlano = this.planos.find(plano => plano.idPlano === zona.idPlano);
      this.selectedZona = zona;
      this.filterUbication();
      this.setSelectedFilters();

      // Sort selectors
      this.proyectos.sort((a) => (a === this.selectedProyecto ? -1 : 0));
      this.planos.sort((a) => (a.idProyecto === this.selectedProyecto.idProyecto ? -1 : 0));
      this.planos.sort((a) => (a === this.selectedPlano ? -1 : 0));
      this.zonas.sort((a) => (a.idPlano === this.selectedPlano.idPlano ? -1 : 0));
      this.zonas.sort((a) => (a === this.selectedZona ? -1 : 0));

    } else {

      // Undefined
      this.selectedZona = undefined;
      this.filterUbication();
    }
  }

  setSelectedFilters() {
    this.setSelectedFilterLum();
    this.setSelectedFilterGW();
  }

  filterLumsByProperties() {
    this.luminariasFiltro = this.luminariasFiltroUbicacion;
    if (this.selectedGWFilterLum) {
      this.luminariasFiltro = this.luminariasFiltro.filter(lum => lum.idConcentradorPpal === this.selectedGWFilterLum);
    }
    if (this.selectedFirmwareVersionFilterLum) {
      this.luminariasFiltro = this.luminariasFiltro.filter(lum => lum.versionFirmware === this.selectedFirmwareVersionFilterLum);
    }
    if (this.selectedEmergenciesFilterLum) {
      this.luminariasFiltro = this.luminariasFiltro.filter(lum => lum.tieneEmergencia === true);
    }
    if (this.selectedPresenceSensorsFilterLum) {
      this.luminariasFiltro = this.luminariasFiltro.filter(lum => this.getTipoSensorLuminaria(lum) == 1 || this.getTipoSensorLuminaria(lum) == 2);
    }
    if (this.selected420SensorsFilterLum) {
      this.luminariasFiltro = this.luminariasFiltro.filter(lum => this.getTipoSensorLuminaria(lum) == 0 || this.getTipoSensorLuminaria(lum) == 2);
    }
    this.searcherLuminariasFunc();
  }

  isAnyLumFilterSelected() {
    return this.selectedGWFilterLum != undefined || this.selectedFirmwareVersionFilterLum != undefined
      || this.selectedEmergenciesFilterLum || this.selectedPresenceSensorsFilterLum || this.selected420SensorsFilterLum;
  }

  unselectAllLumFilters() {
    this.selectGWFilterLum(undefined);
    this.selectFirmwareVersionFilterLum(undefined);
    this.setEmergenciesFilterLum(false);
    this.setPresenceSensorsFilterLum(false);
    this.set420SensorsFilterLum(false);
  }

  setSelectedFilterLum() {
    this.selectGWFilterLum(this.selectedGWFilterLum);
    this.selectFirmwareVersionFilterLum(this.selectedFirmwareVersionFilterLum);
  }

  selectGWFilterLum(idGateway: string) {
    if (this.getGWsByFilteredLums().find(gw => gw === idGateway)) {
      this.selectedGWFilterLum = idGateway;
    } else {
      this.selectedGWFilterLum = undefined;
    }
    this.filterLumsByProperties();
  }

  getGWsByFilteredLums() {
    return [...new Set(this.luminariasFiltroUbicacion.map(luminaria => luminaria.idConcentradorPpal))];
  }

  selectFirmwareVersionFilterLum(firmwareVersion: string) {
    if (this.getFirmwareVersionByFilteredLums().find(fw => fw === firmwareVersion)) {
      this.selectedFirmwareVersionFilterLum = firmwareVersion;
    } else {
      this.selectedFirmwareVersionFilterLum = undefined;
    }
    this.filterLumsByProperties();
  }

  getFirmwareVersionByFilteredLums() {
    return [...new Set(this.luminariasFiltroUbicacion.map(luminaria => luminaria.versionFirmware))];
  }

  setEmergenciesFilterLum(checked: boolean) {
    this.selectedEmergenciesFilterLum = checked;
    this.filterLumsByProperties();
  }

  setPresenceSensorsFilterLum(checked: boolean) {
    this.selectedPresenceSensorsFilterLum = checked;
    this.filterLumsByProperties();
  }

  set420SensorsFilterLum(checked: boolean) {
    this.selected420SensorsFilterLum = checked;
    this.filterLumsByProperties();
  }

  filterGWByProperties() {
    this.concentradoresFiltro = this.concentradoresFiltroUbicacion;
    if (this.selectedChannelFilterGW) {
      this.concentradoresFiltro = this.concentradoresFiltro.filter(gw => gw.channel === this.selectedChannelFilterGW);
    }
    if (this.selectedFirmwareVersionFilterGW) {
      this.concentradoresFiltro = this.concentradoresFiltro.filter(gw => gw.versionFirmware === this.selectedFirmwareVersionFilterGW);
    }
    if (this.selectedCommunicatingFilterGW) {
      this.concentradoresFiltro = this.concentradoresFiltro.filter(gw => gw.lastCommunication >= (Date.now() - 86400000));
    }
    this.concentradores = this.concentradoresFiltro;
    this.orderGW();
  }

  updateDuplicateGatewayWarnings(concentradores: concentrador[]) {
    const groupedGateways = new Map<string, concentrador[]>();
    this.duplicateGatewayIds.clear();

    for (const gateway of concentradores) {
      const key = `${gateway.idProyecto || ''}|${gateway.channel || ''}|${gateway.panId || ''}`;
      if (!groupedGateways.has(key)) {
        groupedGateways.set(key, []);
      }
      groupedGateways.get(key).push(gateway);
    }

    groupedGateways.forEach((group) => {
      if (group.length <= 1) {
        return;
      }

      const sorted = [...group].sort((a, b) => {
        const dateA = a.fechaInstalacion || 0;
        const dateB = b.fechaInstalacion || 0;
        if (dateA !== dateB) {
          return dateB - dateA;
        }
        return a.idDispositivo.localeCompare(b.idDispositivo);
      });

      for (let i = 1; i < sorted.length; i++) {
        this.duplicateGatewayIds.add(sorted[i].idDispositivo);
      }
    });
  }

  isDuplicateGateway(concentrador: concentrador) {
    return this.duplicateGatewayIds.has(concentrador.idDispositivo);
  }

  isAnyGWFilterSelected() {
    return this.selectedChannelFilterGW != undefined || this.selectedFirmwareVersionFilterGW != undefined;
  }

  unselectAllGWFilters() {
    this.selectChannelFilterGW(undefined);
    this.selectFirmwareVersionFilterGW(undefined);
  }

  setSelectedFilterGW() {
    this.selectChannelFilterGW(this.selectedChannelFilterGW);
    this.selectFirmwareVersionFilterGW(this.selectedFirmwareVersionFilterGW);
  }

  selectChannelFilterGW(channel: string) {
    if (this.getChannelsByFilteredGW().find(chann => chann === channel)) {
      this.selectedChannelFilterGW = channel;
    } else {
      this.selectedChannelFilterGW = undefined;
    }
    this.filterGWByProperties();
  }

  getChannelsByFilteredGW() {
    return [...new Set(this.concentradoresFiltroUbicacion.map(gw => gw.channel))];
  }

  selectFirmwareVersionFilterGW(firmware: string) {
    if (this.getFirmwareVersionByFilteredGW().find(firm => firm === firmware)) {
      this.selectedFirmwareVersionFilterGW = firmware;
    } else {
      this.selectedFirmwareVersionFilterGW = undefined;
    }
    this.filterGWByProperties();
  }

  getFirmwareVersionByFilteredGW() {
    return [...new Set(this.concentradoresFiltroUbicacion.map(gw => gw.versionFirmware))];
  }

  setCommunicatingFilterGW(checked: boolean) {
    this.selectedCommunicatingFilterGW = checked;
    this.filterGWByProperties();
  }

  filterSensorByProperties() {
    this.sensoresFiltro = this.sensoresFiltroUbicacion;
    if (!this.selectedAllFilterSensor) {
      let arr = [];
      if (this.selected420FilterSensor) {
        arr.push(0);
      }
      if (this.selectedPresenceFilterSensor) {
        arr.push(1);
      }
      if (this.selectedBothFilterSensor) {
        arr.push(2);
      }
      this.sensoresFiltro = this.sensoresFiltro.filter(sensor => arr.includes(sensor.tipoSensor));
    }
    this.searcherSensorsFunc();
  }

  checkSelectedAllFilterSensor() {
    this.selectedAllFilterSensor = this.selected420FilterSensor && this.selectedPresenceFilterSensor && this.selectedBothFilterSensor;
  }

  setAllFilterSensor(checked: boolean) {
    if (checked == true) {
      this.selectedAllFilterSensor = true;
      this.selected420FilterSensor = true;
      this.selectedPresenceFilterSensor = true;
      this.selectedBothFilterSensor = true;
      this.filterSensorByProperties();
    }
  }

  set420FilterSensor(checked: boolean) {
    this.selected420FilterSensor = checked;
    this.checkSelectedAllFilterSensor();
    this.filterSensorByProperties();
  }

  setPresenceFilterSensor(checked: boolean) {
    this.selectedPresenceFilterSensor = checked;
    this.checkSelectedAllFilterSensor();
    this.filterSensorByProperties();
  }

  setBothFilterSensor(checked: boolean) {
    this.selectedBothFilterSensor = checked;
    this.checkSelectedAllFilterSensor();
    this.filterSensorByProperties();
  }

  selectLuminaria(luminaria: luminaria) {
    this.selectZona(this.zonas.find(zona => zona.id == luminaria.idZona));
    this.selectedLuminariaByFloorplan = luminaria.idDispositivo;
  }

  goBackDaliData() {
    this.showingDaliData = false;
    this.loadingDaliDataTable = false;
    this.showingSensorData = false;
    this.requestingDaliData = false;
    this.selectedLuminaria = undefined;
    this.selectedSensor = undefined;
    this.sensorData = [];
    this.filterUbication();
  }

  generateArray(obj){
    return Object.keys(obj).map((key)=>{
      if (key == "idDaliData") {
        return {key: key, value: "id"}
      }
      return {key: key, value: obj[key]}
    });
  }

  getDate(n: number) {
    let date = new Date(n);
    return date.toLocaleDateString();
  }

  getDateAndHour(n: number) {
    let date = new Date(n);
    return date.toLocaleString();
  }

  getLumCommunicating(luminaria: luminaria) {
    let now = new Date();
    if (luminaria.time_LAST_COM > 0) {
      if (((now.getTime() / 1000) - 86400) > luminaria.time_LAST_COM) {
        return 1;
      } else {
        return 0;
      }
    }
    return 1;
  }

  lastCommunicationTooltip(luminaria: luminaria) {
    let now = new Date();
    if (luminaria.time_LAST_COM > 0) {
      let time = (now.getTime() / 1000) - luminaria.time_LAST_COM;
      if (time > 86400) {
        return "+24h";
      } else {
        let hour = Math.floor(time / 3600);
        let min = Math.floor((time - (hour * 3600)) / 60);
        return hour + "h " + min + "m";
      }
    }
    return "No data";
  }

  getLastEmergency(luminaria: luminaria) {
    if (luminaria.emergencias.emg_LED) {
      return 1;
    } else if (luminaria.emergencias.emg_BATT || luminaria.emergencias.emg_LOAD) {
      return 2;
    } else {
      return 0;
    }
  }

  editLuminaria(lum: luminaria) {
    this.luminariaService.setLumToEdit(lum)
    let dialog = this.matDialog.open(EditComponent, {
      width: '80%',
      height: '90%'
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init();
      }
    });
  }

  searcherLuminariasFunc() {
    this.luminariasOrder = this.luminariasFiltro.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));
    this.orderLums();
  }

  canManageLuminaryDeletes() {
    return this.user.getPermiso() != 'Ateneo' && !this.user.getPermiso().startsWith('Configuraci');
  }

  canDeleteFilteredLuminaries() {
    return this.canManageLuminaryDeletes()
      && this.searcherLuminarias.trim().length > 0
      && this.luminariasOrder.length > 0;
  }

  deleteFilteredLuminaries() {
    if (!this.canDeleteFilteredLuminaries()) {
      return;
    }

    let dialog = this.matDialog.open(DeleteComponent, {
      width: '80%',
      height: '90%',
      data: {
        type: 'lum-batch',
        device: [...this.luminariasOrder]
      }
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.searcherLuminarias = "";
        this.init();
      }
    });
  }

  sendGetHubsMap(idLuminaria) {
    this.parametrosService.loadFromGW(idLuminaria, "MapOfHubs").subscribe((result: parametros[]) => {
      setTimeout(() => {
        this.getLuminarias();
      }, 2000);
    });
  }

  sendGetPeripherals(idLuminaria) {
    if (this.requestingPeripheralsByLuminariaId[idLuminaria] === true) {
      return;
    }

    this.requestingPeripheralsByLuminariaId[idLuminaria] = true;
    this.luminariaService.requestPeripherals(idLuminaria)
      // Red de seguridad: el backend ya responde TIMEOUT a los 10s, pero si ese aviso
      // se pierde (websocket caido) el spinner se quedaria girando para siempre.
      .pipe(timeout(PERIPHERALS_REQUEST_TIMEOUT_MS))
      .pipe(finalize(() => {
        this.requestingPeripheralsByLuminariaId[idLuminaria] = false;
      }))
      .subscribe({
        next: (result: any) => {
          // El backend responde por websocket con COMPLETED o TIMEOUT
          if (result != undefined && result.status != "COMPLETED") {
            return;
          }
          this.refreshLuminaria(idLuminaria);
        },
        error: () => {}
      });
  }

  /*
    Refresca una sola luminaria en vez de recargar toda la tabla. Los arrays de filtrado
    y paginado se construyen con filter/slice sobre luminariasReal, asi que comparten la
    misma referencia de objeto: mutarlo actualiza todas las vistas sin perder la pagina
    actual, los filtros ni la cache de disponibilidad de datos DALI.
   */
  refreshLuminaria(idLuminaria: string) {
    this.luminariaService.getByID(idLuminaria, false).subscribe((response) => {
      let fresh = <luminaria> response;
      let existing = this.luminariasReal.find(lum => lum.idDispositivo === idLuminaria);
      if (fresh == undefined || existing == undefined) {
        return;
      }

      existing.perifericos = fresh.perifericos;
      existing.emergencias = fresh.emergencias;
      existing.rssi = fresh.rssi;
      existing.time_LAST_COM = fresh.time_LAST_COM;
      existing.time_LAST_COM_II = fresh.time_LAST_COM_II;

      // Los perifericos recien leidos pueden revelar un DALI que antes no estaba,
      // asi que hay que volver a consultar la disponibilidad de datos DALI.
      delete this.daliDataAvailabilityByLuminariaId[idLuminaria];
      this.loadDaliDataAvailabilityForVisibleLuminarias();
    });
  }

  getLabelHubConfirmado(boolean_label) {
    return boolean_label ? this.localiser.get("fade.groups.confirmedhub.yes") : this.localiser.get("fade.groups.confirmedhub.no");
  }

  /*
    Unconfirmed means the version comes from the name of the firmware file the last OTA
    sent, not from the luminary: the message that closes an OTA still carries the version
    the luminary was updated from, so the backend writes the expected one and waits for
    the luminary to report a version of its own.
   */
  getLabelVersionConfirmada(boolean_label) {
    return boolean_label ? this.localiser.get("devices.versionConfirmed.yes") : this.localiser.get("devices.versionConfirmed.no");
  }

  editConcentrador(concentrador: concentrador) {
    this.concentradorService.setConcentradorToEdit(concentrador)
    let dialog = this.matDialog.open(EditConcentradorComponent, {
      width: '70%',
      height: '90%',
      data: {
        concentradores: this.getGatewaysMantenimiento(this.concentradores),
        allConcentradores: this.concentradoresReal
      }
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init();
      }
    });
  }

  editSensor(sensor: sensor) {
    this.sensorService.setSensorToEdit(sensor)
    let dialog = this.matDialog.open(EditSensorComponent, {
      width: '70%',
      height: '60%'
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init();
      }
    });
  }

  searcherSensorsFunc() {
    this.sensores = this.sensoresFiltro.filter(sensor =>
      (sensor.nombre.toLowerCase().includes(this.searcherSensors.toLowerCase())) ||
      (sensor.idLuminaria.toLowerCase().includes(this.searcherSensors.toLowerCase())));
  }

  getTipoSensor(tipo: number) {
    if (tipo == 0) {
      return "4-20mA";
    } else if (tipo == 1) {
      return this.localiser.get("devices.presence");
    } else if (tipo == 2) {
      return this.localiser.get("devices.bothSensors");
    }
  }

  getTipoSensorLuminaria(luminaria: luminaria) {
    let sensor = this.sensoresReal.find(sensor => sensor.idLuminaria == luminaria.idDispositivo);
    if (sensor == undefined) {
      return -1;
    }
    return sensor.tipoSensor;

  }

  seeSensorData(sensor: sensor) {
    this.selectedSensor = sensor;
    this.showingSensorData = true;
    this.sensorService.getCountForSensorDataPaginated(sensor.idLuminaria).subscribe((result: number) => {
      this.sensorDataNumber = result;
    });
    this.getSensorDataPaginated(sensor.idLuminaria, 1);
  }

  getSensorDataPaginated(idLuminaria: string, page: number) {
    this.sensorData = [];
    if (page > Math.ceil(this.sensorDataNumber / 100)) {
      page = Math.ceil(this.sensorDataNumber / 100);
    }
    if (page < 1 || page == undefined) {
      page = 1;
    }
    this.actualSensorDataPage = undefined;
    this.changeDetectorRef.detectChanges();
    this.actualSensorDataPage = page;
    this.sensorService.getSensorDataPaginated(idLuminaria, this.actualSensorDataPage - 1, this.orderSensorData).subscribe((response: sensorData[]) => {
      this.sensorData = response;
    });
  }

  changeOrderSensorData(order) {
    this.orderSensorData = order;
    this.getSensorDataPaginated(this.selectedSensor.idLuminaria, 1);
  }

  changeSensorDataPageByNumber(page) {
    if (page != undefined) {
      this.actualSensorDataPage = undefined;
      this.changeDetectorRef.detectChanges();
      this.getSensorDataPaginated(this.selectedSensor.idLuminaria, page);
    }
  }

  outInputChangeSensorDataPageByNumber(event) {
    if (isNaN(event.srcElement.valueAsNumber)) {
      this.getSensorDataPaginated(this.selectedSensor.idLuminaria, 1);
    }
  }

  changeSensorDataPageByArrow(nextPage) {
    this.getSensorDataPaginated(this.selectedSensor.idLuminaria, this.actualSensorDataPage + nextPage);
  }

  isLastSensorDataPage() {
    return Math.ceil(this.sensorDataNumber / 100) == this.actualSensorDataPage || Math.ceil(this.sensorDataNumber / 100) <= 1;
  }

  checkGatewayType(concentrador: concentrador) {
    if (concentrador.panId.split("x").length >= 2) {
      return concentrador.panId.split("x")[1].substring(0,2);
    }
    return "---"
  }

  getGatewaysMantenimiento(concentradores: concentrador[]) {
    return concentradores.filter(concentrador =>
      this.checkGatewayType(concentrador) == "FF"
    );
  }

  /*
    Three arguments for orderVariableLum:
    - orderProperty (string): The property name for do the order
    - orderPropertyIsInDaliData (boolean): If the property is inside the DaliData or is a property of the luminarie itself
    - orderPropertyType (string): The type of the order property
   */
  changeOrderLums(orderProperty: string, orderPropertyType: string) {
    if (this.orderVariableLum.length == 0 || this.orderVariableLum[0] != orderProperty) {
      this.orderValueLum = 2;
    } else if (this.orderValueLum == 1) {
      this.orderValueLum = 2;
    } else if (this.orderValueLum == 2) {
      this.orderValueLum = 1;
    }
    this.orderVariableLum = [orderProperty, orderPropertyType];
    this.searcherLuminariasFunc();
  }

  orderLums() {
    // Order first if there is a lum selected
    if (this.selectedLuminariaByFloorplan != undefined) {
      let t = this;
      this.luminariasOrder.sort(function(x,y) {
        return x.idDispositivo == t.selectedLuminariaByFloorplan ? -1 : y.idDispositivo == t.selectedLuminariaByFloorplan ? 1 : 0;
      });
    }
    this.orderLumsByProperty();
    this.paginateLums(1, 20);
  }

  orderLumsByProperty() {
    if (this.orderVariableLum.length == 0) {
      return;
    }
    if (this.orderVariableLum[1] == "string") {
      if (this.orderValueLum == 1) {
        this.luminariasOrder = this.luminariasOrder.sort((a, b) => {
          if (a[this.orderVariableLum[0]] != undefined && b[this.orderVariableLum[0]] != undefined) {
            return a[this.orderVariableLum[0]].localeCompare(b[this.orderVariableLum[0]]);
          }
        })
      } else if (this.orderValueLum == 2) {
        this.luminariasOrder = this.luminariasOrder.sort((a, b) => {
          if (a[this.orderVariableLum[0]] != undefined && b[this.orderVariableLum[0]] != undefined) {
            return b[this.orderVariableLum[0]].localeCompare(a[this.orderVariableLum[0]]);
          }
        })
      }
    } else {
      if (this.orderValueLum == 1) {
        this.luminariasOrder = this.luminariasOrder.sort((a, b) => {
          if (a[this.orderVariableLum[0]] != undefined && b[this.orderVariableLum[0]] != undefined) {
            return a[this.orderVariableLum[0]] - b[this.orderVariableLum[0]];
          }
        })
      } else if (this.orderValueLum == 2) {
        this.luminariasOrder = this.luminariasOrder.sort((a, b) => {
          if (a[this.orderVariableLum[0]] != undefined && b[this.orderVariableLum[0]] != undefined) {
            return b[this.orderVariableLum[0]] - a[this.orderVariableLum[0]];
          }
        })
      }
    }
  }

  changePageByNumber(page) {
    if (page != undefined) {
      this.actualPage = undefined;
      this.changeDetectorRef.detectChanges();
      this.paginateLums(page, 20);
    }
  }

  outInputChangePageByNumber(event) {
    if (isNaN(event.srcElement.valueAsNumber)) {
      this.paginateLums(1, 20);
    }
  }

  changePageByArrow(nextPage: number) {
    this.paginateLums(this.actualPage + nextPage, 20);
  }

  /*
    Show only 20 luminaries in the list
   */
  paginateLums(page, n) {
    if (page > Math.ceil(this.luminariasOrder.length / n)) {
      page = Math.ceil(this.luminariasOrder.length / n);
    }
    if (page < 1 || page == undefined) {
      page = 1;
    }
    this.actualPage = undefined;
    this.changeDetectorRef.detectChanges();
    this.actualPage = page;
    this.luminarias = this.luminariasOrder.slice(n * (page - 1), n * page);
    this.loadDaliDataAvailabilityForVisibleLuminarias();
  }

  isLastPage() {
    return Math.ceil(this.luminariasOrder.length / 20) == this.actualPage || Math.ceil(this.luminariasOrder.length / 20) <= 1;
  }

  /*
    Three arguments for orderVariableGW:
    - orderProperty (string): The property name for do the order
    - orderPropertyType (string): The type of the order property
   */
  changeOrderGW(orderProperty: string, orderPropertyType: string) {
    if (this.orderVariableGW.length == 0 || this.orderVariableGW[0] != orderProperty) {
      this.orderValueGW = 2;
    } else if (this.orderValueGW == 1) {
      this.orderValueGW = 2;
    } else if (this.orderValueGW == 2) {
      this.orderValueGW = 1;
    }
    this.orderVariableGW = [orderProperty, orderPropertyType];
    this.orderGW();
  }

  orderGW() {
    if (this.orderVariableGW.length == 0) {
      return;
    }
    if (this.orderVariableGW[1] == "string") {
      if (this.orderValueGW == 1) {
        this.concentradores = this.concentradores.sort((a, b) => {
          if (a[this.orderVariableGW[0]] != undefined && b[this.orderVariableGW[0]] != undefined) {
            return a[this.orderVariableGW[0]].localeCompare(b[this.orderVariableGW[0]]);
          }
        })
      } else if (this.orderValueGW == 2) {
        this.concentradores = this.concentradores.sort((a, b) => {
          if (a[this.orderVariableGW[0]] != undefined && b[this.orderVariableGW[0]] != undefined) {
            return b[this.orderVariableGW[0]].localeCompare(a[this.orderVariableGW[0]]);
          }
        })
      }
    } else {
      if (this.orderValueGW == 1) {
        this.concentradores = this.concentradores.sort((a, b) => {
          if (a[this.orderVariableGW[0]] != undefined && b[this.orderVariableGW[0]] != undefined) {
            return a[this.orderVariableGW[0]] - b[this.orderVariableGW[0]];
          }
        })
      } else if (this.orderValueGW == 2) {
        this.concentradores = this.concentradores.sort((a, b) => {
          if (a[this.orderVariableGW[0]] != undefined && b[this.orderVariableGW[0]] != undefined) {
            return b[this.orderVariableGW[0]] - a[this.orderVariableGW[0]];
          }
        })
      }
    }
  }

  blinkLuminaire(idDispositivo) {
    let json =
      {
        "idDispositivo": idDispositivo,
        "cmd": "blink",
        "arg": 2
      };
    this.luminariaService.sendOrden(json);
  }

  deleteDevice(type, device) {
    let dialog = this.matDialog.open(DeleteComponent, {
      width: '80%',
      height: '90%',
      data: {type: type, device: device}
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init();
      }
    });
  }

  goToLimits() {
    this.navigation.toLimits();
  }

  openOptions() {
    let dialog = this.matDialog.open(OptionsComponent, {
      width: '80%',
      height: '80%',
      data: {luminaries: this.luminariasReal, projects: this.proyectos, floorplans: this.planos, zones: this.zonas,
      sensors: this.sensoresReal}
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init();
      }
    });
  }

}
